<script>
  import { createEventDispatcher } from "svelte"

  const dispatch = createEventDispatcher()

  export let label
  export let current
  let disabled

  $: disabled = current

  function onClick() {
    if (disabled) return
    dispatch("click", {
      tab: label,
    })
  }
</script>

<button aria-current={current} {disabled} on:click={onClick}>{label}</button>

<style>
  button {
    all: unset;
    box-sizing: border-box;

    font-size: var(--font-size-m);
    line-height: var(--line-height-m);

    height: calc(var(--line-height-m) * 1.5);

    background-color: var(--white);
    color: var(--grey);

    padding: 0 0.6em;

    white-space: nowrap;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: stretch;
    align-items: center;

    border-radius: var(--border-radius);
    border: 1px solid var(--grey-light);

    text-transform: capitalize;
  }

  button[aria-current="true"] {
    color: var(--black);
  }

  button:not([disabled]) {
    cursor: pointer;
  }
</style>
